import { arrayBuilderItemSubsequentPageTitleUI } from 'platform/forms-system/src/js/web-component-patterns';

import {
  conditionDateSchema,
  conditionDateUI,
  forceFieldBlurSchema,
  forceFieldBlurUI,
} from './conditionDateField';
import { backfillCauseForIncreaseRows } from './utils';

/**
 * Builds the "When did your condition get worse?" page.
 *
 * @param {Object} [options]
 * @param {boolean} [options.monthYearOnly=false] - When true, the date field
 *   renders only the month and year inputs (no day input). Used by
 *   all-claims-v2; the original all-claims flow keeps the full date.
 * @returns {PageSchema}
 */
export const createRatedDisabilityDatePage = ({
  monthYearOnly = false,
} = {}) => ({
  uiSchema: {
    ...arrayBuilderItemSubsequentPageTitleUI(
      ({ formData }) =>
        `${formData?.ratedDisability || 'service-connected disability'}`,
    ),
    conditionDate: conditionDateUI({
      title: 'When did your condition get worse?',
      fullDateHint:
        'You can share an approximate date. If your condition started in the winter of 2020, enter December 1, 2020.',
      monthYearOnly,
      validations: [backfillCauseForIncreaseRows],
    }),
    'view:forceFieldBlur': forceFieldBlurUI,
  },
  schema: {
    type: 'object',
    properties: {
      conditionDate: conditionDateSchema(monthYearOnly),
      'view:forceFieldBlur': forceFieldBlurSchema,
    },
  },
});

/** @type {PageSchema} full month/day/year variant used by all-claims (v1) */
const ratedDisabilityDatePage = createRatedDisabilityDatePage();

export default ratedDisabilityDatePage;
